import PhaseSixIcon from "../../basic/phaseSixIcon/PhaseSixIcon";
import { FormattedText } from "./FormattedText";

interface ListItemWithCheckProps {
    text: string;
}

export const ListItemWithCheck = (props: ListItemWithCheckProps) => {
    return (
        <li className="gap-xs flex flex-row items-center text-start">
            <PhaseSixIcon
                name="exercise-ok"
                className="text-forest-green-800 text-xl"
            />
            <FormattedText
                rawText={props.text}
                textColor="text-stone-1000"
            />
        </li>
    );
};
